var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-8 green lighten-5 rounded overflow-hidden"},[_c('div',{staticClass:"mx-8 my-4",domProps:{"innerHTML":_vm._s(_vm.renderedContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }